import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { FormTemplateData } from "@/modules/FormTemplate/models/FormTemplateData";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import {
  BASIC_FILTERS,
  FORMS_FILTERS_LIST
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { FilterResultModel } from "@/modules/ServiceTemplate/models/FiltersResultModel";
import { SectionGroup } from "@/modules/ServiceTemplate/models/SectionGroup";
import { SectionGroupDetail } from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import CardAddForm from "@/shared/components/CardAddForm/CardAddForm.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES
} from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "@/shared/constants/GeneralConstants";
import { QuerySend } from "@/shared/models/FormQuerySend";
import { SearchFilter } from "@/shared/models/SearchFilter";
import { Http } from "@status/codes";
import { Component, Inject, Vue } from "vue-property-decorator";
import Snackbar from "../Snackbar/Snackbar";
import { FIND_FORM_TEMPLATE_CONSTANTS } from "./constants/FindFormTemplateConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";

@Component({
  name: "FindFormTemplate",
  components: {
    CardAddForm,
    EmptyState,
    FormModalViewer,
    GenericSearchBar
  }
})
export default class FindFormTemplate extends Vue {
  @Inject() formTemplateService!: FormTemplateService;
  sectionGroup = new SectionGroup();

  formsFilterArray = FORMS_FILTERS_LIST;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  SEARCH_FIND_FORM_TEMPLATE_KEY = NAME_FINDERS.FIND_FORM_TEMPLATE;
  btnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  rowForms = STYLE_CLASSES.ROW_FORMS;

  formTempDataList: Array<FormStatus> = [];
  filterQueryForms: QuerySend = {};
  loadingData = false;
  showCardsContainer = false;
  formsItems: SearchFilter[] = BASIC_FILTERS.FORMS;
  formTemplateData: FormTemplateData = new FormTemplateData();
  dateCreated = "";
  dateModified = "";
  viewFormTempDialog = false;
  clearModel = false;
  lastRef = "";

  async getFormsFilterEvents(data: FilterResultModel) {
    delete data.mainFilterKey;
    this.formsItems[0].value = data.name ? data.name[0] : "";
    this.formsItems[1].value = data.category ? data.category[0] : "";

    this.lastRef = "";
    await this.searchTemplates(false, true);
  }

  async searchTemplates(shouldPaginate?: boolean, shouldSearch?: boolean) {
    try {
      this.loadingData = true;
      this.filterQueryForms = {
        state: FORM_CONSTANTS.STATE.ACTIVE,
        paginatedResult: true
      };
      if (!shouldSearch) {
        this.showCardsContainer = false;
        this.loadingData = false;
        return;
      }
      if (this.lastRef) {
        this.filterQueryForms.docref = this.lastRef;
      }
      if (this.formsItems[0].value !== "") {
        this.filterQueryForms.name = this.formsItems[0].value;
      }
      if (this.formsItems[1].value !== "") {
        this.filterQueryForms.category = this.formsItems[1].value;
      }
      const formTempList = await this.formTemplateService.getFormTemplateWithFilters(
        this.filterQueryForms
      );

      this.loadingData = false;

      if (formTempList.code === Http.Found && formTempList.data) {
        if (shouldPaginate) {
          this.formTempDataList = [
            ...this.formTempDataList,
            ...formTempList.data.data
          ];
        } else {
          this.formTempDataList = formTempList.data.data;
        }
        this.lastRef = formTempList.data.docref;
        this.showCardsContainer = true;
      } else {
        if (!shouldPaginate) {
          this.formTempDataList = [];
        }
        if (formTempList.code === Http.NotFound)
          Snackbar.popInfo(FORM_MESSAGES.NOT_FOUND_TEMPLATES);
        else Snackbar.popError(formTempList.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      this.loadingData = false;
      Snackbar.popError(errorMessage);
    }
  }

  closeModalPreview() {
    this.viewFormTempDialog = false;
    this.clearModel = false;
  }

  async viewFormTemp(id: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateSchemaById(
        id
      );
      if (response.code !== Http.Found || response.data == null) {
        throw new Error(response.message);
      }
      this.formTemplateData = response.data;
      this.dateCreated = this.formTemplateData.dateCreated
        ? new Date(this.formTemplateData.dateCreated).toLocaleString(
            FIND_FORM_TEMPLATE_CONSTANTS.VAR.ES_CO
          )
        : "";
      this.dateModified = this.formTemplateData.dateChanged
        ? new Date(this.formTemplateData.dateChanged).toLocaleString(
            FIND_FORM_TEMPLATE_CONSTANTS.VAR.ES_CO
          )
        : "";
      this.viewFormTempDialog = true;
      this.clearModel = true;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${FORM_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  addForm(index: number) {
    const newFormTemp: SectionGroupDetail = {
      name: this.formTempDataList[index].name,
      id: this.formTempDataList[index]._key,
      icon: this.formTempDataList[index].icon ?? "",
      multiple: this.formTempDataList[index].multiple ?? false
    };
    this.$emit(
      FIND_FORM_TEMPLATE_CONSTANTS.EMIT.INSERT_FORM_TEMPALTE,
      newFormTemp
    );
    (this.sectionGroup.formTemplates as SectionGroupDetail[]).push(newFormTemp);
  }

  async onBottomScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchTemplates(true, true);
    }
  }

  close() {
    this.$emit(FIND_FORM_TEMPLATE_CONSTANTS.EMIT.CLOSE);
  }
}
